import { URL, handleErrors } from "./depannageActions"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

export const CLEAR_MUST_CHANGE = "CLEAR_MUST_CHANGE"

export const clearMustChangePassword = () => ({
	type: CLEAR_MUST_CHANGE,
})

// Bloc B : changement de mot de passe. Au succès, lève le flag local
// (le back lève must_change_password en base) → l'app se débloque.
export function changePassword(data) {
	return (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/change-password`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then(() => {
				dispatch(clearMustChangePassword())
				dispatch(showToast("success", "Mot de passe changé."))
				return true
			})
			.catch(catchApiError(dispatch, null))
	}
}

export const POST_LOGIN_BEGIN = "POST_LOGIN_BEGIN"
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS"
export const POST_LOGIN_ERROR = "POST_LOGIN_ERROR"
export const POST_LOGIN_RESET = "POST_LOGIN_RESET"

export const postLoginBegin = () => ({
	type: POST_LOGIN_BEGIN,
})

export const postLoginSuccess = (payload) => ({
	type: POST_LOGIN_SUCCESS,
	payload,
})

export const postLoginError = (error) => ({
	type: POST_LOGIN_ERROR,
	payload: error,
})

export const postLoginReset = () => ({
	type: POST_LOGIN_RESET,
})

export function postLogin(data) {
	return (dispatch) => {
		dispatch(postLoginBegin())
		return fetch(`${URL}api/loginv2`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postLoginSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, postLoginError, { silent: true }))
	}
}

export function disconnectLogin() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/ficheouverte`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		}).catch(() => {}) // un logout ne doit jamais bloquer
	}
}
